export default "p b {\n    color: rgb(190, 0, 0);\n    font-style: italic;\n    font-size: smaller;\n  }\n\ninput[type=\"text\"] {\n    width: 100%;\n}"